import { handleError } from "../../../util/errors";
import apiBase from "../../api";

class LpfrLicencesService {
  // Paginated list of L-PFR licences (one per secure element UID), newest contact first.
  fetchLicences = async ({ search = "", page = 1, perPage = 20 } = {}) => {
    try {
      const params = new URLSearchParams();
      if (search) params.append("search", search);
      params.append("page", page);
      params.append("perPage", perPage);
      const response = await apiBase.get(
        `/fiscal-devices/lpfr/licences?${params.toString()}`
      );
      if (response.status !== 200) throw new Error();
      return response.data?.data;
    } catch (err) {
      throw handleError(err, "Greška pri učitavanju LPFR licenci");
    }
  };

  // changes: any of { status: 'active'|'disabled', expiresAt: ms|null, note: string }.
  // Creates the licence when the UID never checked in.
  updateLicence = async (uid, changes) => {
    try {
      const response = await apiBase.patch(
        `/fiscal-devices/lpfr/licences/${encodeURIComponent(uid)}`,
        changes
      );
      if (response.status !== 200) throw new Error();
      return response.data?.data;
    } catch (err) {
      throw handleError(err, "Greška pri izmeni LPFR licence");
    }
  };
}

const lpfrLicencesService = new LpfrLicencesService();

export default lpfrLicencesService;
